module.exports = __webpack_public_path__ + "static/img/21_住戶反映.eb445fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/21_住戶反映.png
// module id = avft
// module chunks = 1